module.exports = __webpack_public_path__ + "static/media/D.69f04260.png";